import React, { FC } from "react";

import { useTranslation } from "react-i18next";

import { useNavigate } from "react-router-dom";

import { GiAlarmClock } from "react-icons/gi";

export const FastMoney: FC = () => {
  const { t } = useTranslation();

  const navigate = useNavigate();

  const redirectHandler = () => {
    navigate("/register");
  };

  return (
    <>
      <div className="container">
        <div className="mark__inner">
          <div className="mark__info--inner">
            <div className="mark__info">
              <p className="mark__info--title">Fast money</p>

              <p className="mark__info--text">{t("Fast.title1")}</p>

              <div className="mark__point--inner">
                <div className="mark__point">
                  <img
                    src="/assets/img/check-blue.svg"
                    alt="Галочка"
                    className="mark__point--check"
                  />
                  {t("Fast.title2")}
                </div>

                <div className="mark__point">
                  <img
                    src="/assets/img/check-blue.svg"
                    alt="Галочка"
                    className="mark__point--check"
                  />
                  {t("Fast.title3")}
                </div>

                <div className="mark__point">
                  <img
                    src="/assets/img/check-blue.svg"
                    alt="Галочка"
                    className="mark__point--check"
                  />
                  {t("Fast.title4")}
                </div>

                <div className="mark__point">
                  <img
                    src="/assets/img/check-blue.svg"
                    alt="Галочка"
                    className="mark__point--check"
                  />
                  {t("Fast.title5")}
                </div>

                <div className="mark__point">
                  <img
                    src="/assets/img/check-blue.svg"
                    alt="Галочка"
                    className="mark__point--check"
                  />
                  {t("Fast.title6")}
                </div>

                <div className="mark__point">
                  <img
                    src="/assets/img/check-blue.svg"
                    alt="Галочка"
                    className="mark__point--check"
                  />
                  {t("Fast.title7")}
                </div>
              </div>
            </div>

            <GiAlarmClock className="mark__info--img" />
          </div>
        </div>

        <div className="mark__content">
          <div className="mark__item">
            <div className="mark__wrap">
              <div className="mark__item--wrapper">
                <div className="mark__wrapper">
                  <p className="mark__wrapper--title">1 {t("Fast.matrix")}</p>

                  <p className="mark__wrapper--text">Fast Money</p>
                </div>

                <p className="mark__item--wrapper--text">
                  1 $ {t("Fast.curators")}
                </p>
              </div>

              <div className="mark__item--entry">{t("Fast.entry")}: 12 $</div>

              <div className="mark__item--content">
                <img
                  src="assets/img/man1.png"
                  alt="Картинка"
                  className="mark__item--img"
                />

                <p className="mark__item--val big line">12</p>

                <div className="mark__item--box">
                  <div className="mark__item--box--item">
                    <img
                      src="assets/img/man2.png"
                      alt="Картинка"
                      className="mark__item--img"
                    />

                    <p className="mark__item--val">10</p>
                  </div>

                  <div className="mark__item--box--item">
                    <img
                      src="assets/img/man3.png"
                      alt="Картинка"
                      className="mark__item--img"
                    />

                    <p className="mark__item--val">10</p>

                    <div className="mark__item--box--text--inner">
                      <p className="mark__item--box--text">
                        30 $ - {t("Fast.transition")}
                      </p>
                    </div>
                  </div>

                  <div className="mark__item--box--item">
                    <img
                      src="assets/img/man4.png"
                      alt="Картинка"
                      className="mark__item--img"
                    />

                    <p className="mark__item--val">10</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="mark__item--desc"></div>

            <button
              onClick={() => redirectHandler()}
              className="button default__button mark__item--button"
            >
              {t("Fast.participate")}
            </button>
          </div>

          <div className="mark__item">
            <div className="mark__wrap">
              <div className="mark__item--wrapper">
                <div className="mark__wrapper">
                  <p className="mark__wrapper--title">2 {t("Fast.matrix")}</p>

                  <p className="mark__wrapper--text">Fast Money</p>
                </div>

                <p className="mark__item--wrapper--text">
                  1 $ {t("Fast.curators")}
                </p>
              </div>

              <div className="mark__item--entry">{t("Fast.entry")}: 30 $</div>

              <div className="mark__item--content">
                <img
                  src="assets/img/man1.png"
                  alt="Картинка"
                  className="mark__item--img"
                />

                <p className="mark__item--val big line">30</p>

                <div className="mark__item--box">
                  <div className="mark__item--box--item">
                    <img
                      src="assets/img/man2.png"
                      alt="Картинка"
                      className="mark__item--img"
                    />

                    <p className="mark__item--val">28</p>

                    <div className="mark__item--box--text--inner">
                      <p className="mark__item--box--text">{t("Fast.desc1")}</p>

                      <p className="mark__item--box--text">{t("Fast.desc2")}</p>

                      <p className="mark__item--box--text">
                        4 $ {t("Fast.for_withdrawal")}
                      </p>
                    </div>
                  </div>

                  <div className="mark__item--box--item">
                    <img
                      src="assets/img/man3.png"
                      alt="Картинка"
                      className="mark__item--img"
                    />

                    <p className="mark__item--val">28</p>

                    <div className="mark__item--box--text--inner">
                      <p className="mark__item--box--text">
                        8 $ {t("Fast.for_withdrawal")}
                      </p>
                      <p className="mark__item--box--text">
                        20 $ {t("Fast.accumulation")}
                      </p>
                    </div>
                  </div>

                  <div className="mark__item--box--item">
                    <img
                      src="assets/img/man4.png"
                      alt="Картинка"
                      className="mark__item--img"
                    />

                    <p className="mark__item--val">28</p>

                    <div className="mark__item--box--text--inner">
                      <p className="mark__item--box--text">
                        8 $ {t("Fast.for_withdrawal")}
                      </p>

                      <p className="mark__item--box--text">
                        20 $ {t("Fast.desc3")}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="mark__item--desc"></div>

            <button
              onClick={() => redirectHandler()}
              className="button default__button mark__item--button"
            >
              {t("Fast.participate")}
            </button>
          </div>

          <div className="mark__item">
            <div className="mark__wrap">
              <div className="mark__item--wrapper">
                <div className="mark__wrapper">
                  <p className="mark__wrapper--title">3 {t("Fast.matrix")}</p>

                  <p className="mark__wrapper--text">Fast Money</p>
                </div>

                <p className="mark__item--wrapper--text">
                  1 $ {t("Fast.curators")}
                </p>
              </div>

              <div className="mark__item--entry">{t("Fast.entry")}: 40 $</div>

              <div className="mark__item--content">
                <img
                  src="assets/img/man1.png"
                  alt="Картинка"
                  className="mark__item--img"
                />

                <p className="mark__item--val big line">40</p>

                <div className="mark__item--box">
                  <div className="mark__item--box--item">
                    <img
                      src="assets/img/man2.png"
                      alt="Картинка"
                      className="mark__item--img"
                    />

                    <p className="mark__item--val">38</p>

                    <div className="mark__item--box--text--inner">
                      <p className="mark__item--box--text">{t("Fast.desc4")}</p>

                      <p className="mark__item--box--text">{t("Fast.desc5")}</p>
                    </div>
                  </div>

                  <div className="mark__item--box--item">
                    <img
                      src="assets/img/man3.png"
                      alt="Картинка"
                      className="mark__item--img"
                    />

                    <p className="mark__item--val">38</p>

                    <div className="mark__item--box--text--inner">
                      <p className="mark__item--box--text">
                        10 $ {t("Fast.for_withdrawal")}
                      </p>

                      <p className="mark__item--box--text">
                        30 $ {t("Fast.accumulation")}
                      </p>
                    </div>
                  </div>

                  <div className="mark__item--box--item">
                    <img
                      src="assets/img/man4.png"
                      alt="Картинка"
                      className="mark__item--img"
                    />

                    <p className="mark__item--val">38</p>

                    <div className="mark__item--box--text--inner">
                      <p className="mark__item--box--text">
                        8 $ {t("Fast.for_withdrawal")}
                      </p>

                      <p className="mark__item--box--text">{t("Fast.desc6")}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="mark__item--desc"></div>

            <button
              onClick={() => redirectHandler()}
              className="button default__button mark__item--button"
            >
              {t("Fast.participate")}
            </button>
          </div>

          <div className="mark__item">
            <div className="mark__wrap">
              <div className="mark__item--wrapper">
                <div className="mark__wrapper">
                  <p className="mark__wrapper--title">4 {t("Fast.matrix")}</p>

                  <p className="mark__wrapper--text">Fast Money</p>
                </div>

                <p className="mark__item--wrapper--text">
                  1 $ {t("Fast.curators")}
                </p>
              </div>

              <div className="mark__item--entry">{t("Fast.entry")}: 60 $</div>

              <div className="mark__item--content">
                <img
                  src="assets/img/man1.png"
                  alt="Картинка"
                  className="mark__item--img"
                />

                <p className="mark__item--val big line">60</p>

                <div className="mark__item--box">
                  <div className="mark__item--box--item">
                    <img
                      src="assets/img/man2.png"
                      alt="Картинка"
                      className="mark__item--img"
                    />

                    <p className="mark__item--val">58</p>

                    <div className="mark__item--box--text--inner">
                      <p className="mark__item--box--text">{t("Fast.desc7")}</p>

                      <p className="mark__item--box--text">{t("Fast.desc8")}</p>

                      <p className="mark__item--box--text">
                        16 $ {t("Fast.accumulation")}
                      </p>
                    </div>
                  </div>

                  <div className="mark__item--box--item">
                    <img
                      src="assets/img/man3.png"
                      alt="Картинка"
                      className="mark__item--img"
                    />

                    <p className="mark__item--val">58</p>

                    <div className="mark__item--box--text--inner">
                      <p className="mark__item--box--text">
                        15 $ {t("Fast.for_withdrawal")}
                      </p>

                      <p className="mark__item--box--text">
                        40 $ {t("Fast.accumulation")}
                      </p>
                    </div>
                  </div>

                  <div className="mark__item--box--item">
                    <img
                      src="assets/img/man4.png"
                      alt="Картинка"
                      className="mark__item--img"
                    />

                    <p className="mark__item--val">58</p>

                    <div className="mark__item--box--text--inner">
                      <p className="mark__item--box--text">
                        15 $ {t("Fast.for_withdrawal")}
                      </p>

                      <p className="mark__item--box--text">{t("Fast.desc9")}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="mark__item--desc"></div>

            <button
              onClick={() => redirectHandler()}
              className="button default__button mark__item--button"
            >
              {t("Fast.participate")}
            </button>
          </div>

          <div className="mark__item">
            <div className="mark__wrap">
              <div className="mark__item--wrapper">
                <div className="mark__wrapper">
                  <p className="mark__wrapper--title">5 {t("Fast.matrix")}</p>

                  <p className="mark__wrapper--text">Fast Money</p>
                </div>

                <p className="mark__item--wrapper--text">
                  2 $ {t("Fast.curators")}
                </p>
              </div>

              <div className="mark__item--entry">{t("Fast.entry")}: 96 $</div>

              <div className="mark__item--content">
                <img
                  src="assets/img/man1.png"
                  alt="Картинка"
                  className="mark__item--img"
                />

                <p className="mark__item--val big line">96</p>

                <div className="mark__item--box">
                  <div className="mark__item--box--item">
                    <img
                      src="assets/img/man2.png"
                      alt="Картинка"
                      className="mark__item--img"
                    />

                    <p className="mark__item--val">92</p>

                    <div className="mark__item--box--text--inner">
                      <p className="mark__item--box--text">
                        {t("Fast.desc10")}
                      </p>

                      <p className="mark__item--box--text">
                        {t("Fast.desc11")}
                      </p>

                      <p className="mark__item--box--text">
                        28 $ {t("Fast.for_withdrawal")}
                      </p>

                      <p className="mark__item--box--text">
                        40 $ {t("Fast.accumulation")}
                      </p>
                    </div>
                  </div>

                  <div className="mark__item--box--item">
                    <img
                      src="assets/img/man3.png"
                      alt="Картинка"
                      className="mark__item--img"
                    />

                    <p className="mark__item--val">92</p>

                    <div className="mark__item--box--text--inner">
                      <p className="mark__item--box--text">
                        {t("Fast.desc12")}
                      </p>

                      <p className="mark__item--box--text">
                        {t("Fast.desc13")}
                      </p>

                      <p className="mark__item--box--text">
                        28 $ {t("Fast.for_withdrawal")}
                      </p>

                      <p className="mark__item--box--text">
                        40 $ {t("Fast.accumulation")}
                      </p>
                    </div>
                  </div>

                  <div className="mark__item--box--item">
                    <img
                      src="assets/img/man4.png"
                      alt="Картинка"
                      className="mark__item--img"
                    />

                    <p className="mark__item--val">92</p>

                    <div className="mark__item--box--text--inner">
                      <p className="mark__item--box--text">
                        {t("Fast.desc14")}
                      </p>

                      <p className="mark__item--box--text">
                        {t("Fast.desc15")}
                      </p>

                      <p className="mark__item--box--text">
                        28 $ на {t("Fast.for_withdrawal")}
                      </p>

                      <p className="mark__item--box--text">
                        40 $ {t("Fast.desc16")} Travel money
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="mark__item--desc">{t("Fast.desc17")}</div>

            <button
              onClick={() => redirectHandler()}
              className="button default__button mark__item--button"
            >
              {t("Fast.participate")}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};
